import { render, staticRenderFns } from "./FormImage.vue?vue&type=template&id=c03506b2&scoped=true"
import script from "./FormImage.vue?vue&type=script&lang=js"
export * from "./FormImage.vue?vue&type=script&lang=js"
import style0 from "./FormImage.vue?vue&type=style&index=0&id=c03506b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03506b2",
  null
  
)

export default component.exports